import {CodeData} from "common/codedata/source/CodeDataSource";
import codeDataStore from "common/codedata/store/CodeDataStore";
import {toJS} from "mobx";
import React from "react";
import ObjectUtil from "utils/ObjectUtil";
import useUIValidator from "common/validation/component/UseUIValidator";
import message from "../../common/message/source/MessageSource";

export interface UISelectProps {
    value?: any;
    valueChanged?: (value: any) => void;
    autoFocus?: boolean;
    setFocus?: boolean;
    firstName?: "all" | "none" | "sel" | "select" | "write" | "전체" | "선택";
    codeData?: CodeData[] | string;
    full?: boolean;
    className?: string;
    style?: React.CSSProperties;
    attrs?: React.SelectHTMLAttributes<HTMLSelectElement>;
    defaultIndex?: number;
    rules?: Array<"required" | ((value: any) => string | undefined)>;
}

export default UISelect;

function UISelect({
                      value,
                      valueChanged,
                      autoFocus,
                      setFocus,
                      firstName,
                      codeData,
                      full,
                      className="tf tf-md",
                      style = {},
                      attrs = {},
                      defaultIndex,
                      rules = []
                  }: UISelectProps) {
    const [codeDatas, setCodeDatas] = React.useState<CodeData[]>();
    const {required, valueChecker, errorClassName, setElement} = useUIValidator({rules: rules})
    let selectRef = React.useRef<HTMLSelectElement>(null);

    React.useEffect(() => {
        valueChecker.setValue(value);
    }, [value]);

    React.useEffect(() => {
        if (Array.isArray(toJS(codeData))) {
            setCodeDatas(getCodataFromFirstName([...(codeData as CodeData[])]));
        } else if (typeof codeData === "string") {
            (async (codeDataKey: string) => {
                setCodeDatas(getCodataFromFirstName(await codeDataStore.readOnce(codeDataKey)));
            })(codeData);
        }
    },[JSON.stringify(codeData)]);

    React.useEffect(() => {
        const propValue: string = value == null ? "" : value + "";
        const elemValue: string = selectRef.current?.value == null ? "" : selectRef.current?.value + "";

        if (propValue !== elemValue) {
            const index = defaultIndex != null ? defaultIndex : firstName == null ? null : 0;

            if (index == null) {
                if(selectRef.current) selectRef.current.value = propValue;
            } else if (codeDatas != null) {
                if (valueChanged == null) {
                    if(selectRef.current) selectRef.current.value = codeDatas[index].code;
                } else {
                    valueChanged(codeDatas[index].code);
                }
            }
        }
    });

    React.useEffect(() => {
        if (setFocus === true) {
            selectRef.current?.focus();
        }
    }, [setFocus])

    React.useEffect(() => {
        setElement(selectRef?.current)
    }, [selectRef]);

    React.useEffect(() => {

    }, [codeDatas])

    function getCodataFromFirstName(codeDatas: CodeData[]) {
        const codeDatasTemp = [...codeDatas];
        if (firstName != null && codeDatas?.findIndex((codeData: CodeData) => codeData.code === "") === -1) {
            codeDatasTemp.splice(0, 0, {
                code: "",
                name: message.get(`common.codeData.firstName.${firstName}`),
                // name: firstName,
            });
        }
        return codeDatasTemp;
    }

    if (full === true) {
        style.width = "100%";
    }

    return (
        <select
            ref={selectRef}
            value={value}
            className={className}
            style={style}
            {...attrs}
            autoFocus={autoFocus === true}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                if (valueChanged != null) {
                    valueChanged(event.target.value);
                }
            }}
            onMouseOver={(event: React.MouseEvent<HTMLSelectElement, MouseEvent>) => {
                const select = event.currentTarget;
                const selectedIndex = select.options.selectedIndex;

                if (selectedIndex !== -1) {
                    select.title = select.options[selectedIndex].text;
                } else {
                    select.title = "";
                }
            }}
            required={required}
            data-value-rule={rules}
            data-validation-message={valueChecker.message}
        >
            {codeDatas?.map((option: CodeData) => (
                <option key={option.code} value={option.code}>
                    {option.name}
                </option>
            ))}
        </select>
    );
}
